module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"« About HoneyMoney":"« О ХаниМани","Demo Bee":"Демо-Пчёл ХаниМани","Try HoneyMoney":"Зарегистрироваться »"}}')
  delete Component.options._Ctor
}
